// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
/**
 * This enumeration defines presentation modes (or display modes) supported by [[InteractiveMesh]].
 *
 * For using this enum please use its implementation from [[OccViewer.DisplayMode]].
 */
export var DisplayMode;
(function (DisplayMode) {
    /** Hollow wireframe geometry (face edges). */
    DisplayMode[DisplayMode["Wireframe"] = 0] = "Wireframe";
    /** Shaded interior with smooth normals. */
    DisplayMode[DisplayMode["SmoothShading"] = 1] = "SmoothShading";
    /** Shaded interior with smooth normals and face edges. */
    DisplayMode[DisplayMode["EdgeShading"] = 2] = "EdgeShading";
    /** Shaded interior with flat normals. */
    DisplayMode[DisplayMode["FlatShading"] = 3] = "FlatShading";
    /** Hidden line removal (HLR). */
    DisplayMode[DisplayMode["HiddenLine"] = 4] = "HiddenLine";
    /** Transparent mode with predefined color. */
    DisplayMode[DisplayMode["TransparentMono"] = 5] = "TransparentMono";
})(DisplayMode || (DisplayMode = {}));
